// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"89fa60e0","453":"7b351efe"}[chunkId] + ".chunk.js";
};